<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>{{ pageTitle }}</span>
      <el-button type="primary" style="width: 92px" @click="back" size="medium"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-form
          :model="healthCardSetForm"
          :rules="rules"
          ref="healthCardSetRef"
          label-width="130px"
          class="healthCardSetRef-ruleForm"
        >
          <el-form-item label="养身卡名称" prop="card_title">
            <el-input
              v-model="healthCardSetForm.card_title"
              size="small"
              clearable
              maxlength="10"
              :disabled="isLook"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="营销标题" prop="title">
            <el-input
              v-model="healthCardSetForm.title"
              style="width: 400px"
              size="small"
              clearable
              maxlength="20"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="营销副标题" prop="desc" class="desc">
            <el-input
              v-model="healthCardSetForm.desc"
              style="width: 400px"
              type="textarea"
              size="small"
              clearable
              maxlength="50"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="原价" prop="market_price">
            <el-input-number
              v-model="healthCardSetForm.market_price"
              size="small"
              :min="0.01"
              :max="999999999"
              :precision="2"
              :controls="false"
              :disabled="isLook"
            ></el-input-number>
            <span>&nbsp;元</span>
          </el-form-item>

          <el-form-item label="售价" prop="price">
            <el-input-number
              v-model="healthCardSetForm.price"
              size="small"
              :min="0.01"
              :max="999999999"
              :precision="2"
              :controls="false"
              :disabled="isLook"
            ></el-input-number>
            <span>&nbsp;元</span>
          </el-form-item>

          <el-form-item label="有效期" prop="saved_day">
            <el-input-number
              v-model="healthCardSetForm.saved_day"
              size="small"
              :min="1"
              :max="999999999"
              :precision="0"
              :controls="false"
              :disabled="isLook"
            ></el-input-number>
            <span>&nbsp;天</span>
          </el-form-item>

          <el-form-item
            label="诊疗优惠券"
            prop="clinic_coupon"
            class="coupon-box"
          >
            <draggable
              v-model="healthCardSetForm.clinic_coupon"
              style="display: inline-block"
            >
              <transition-group name="flip-list" tag="div" class="tag-box">
                <div
                  v-for="(item, index) in healthCardSetForm.clinic_coupon"
                  :key="index"
                >
                  <el-tag
                    :closable="!isLook"
                    size="samll"
                    :disable-transitions="false"
                    @close="handleClinicOrShopClose(1, item)"
                  >
                    <div>
                      <div class="coupon-name">{{ item.coupon_name }}</div>
                      <div class="message-text">{{ item.use_condition }}</div>
                    </div>
                  </el-tag>
                </div>
              </transition-group>
            </draggable>
            <el-button
              v-if="healthCardSetForm.clinic_coupon.length < 20"
              type="primary"
              size="small"
              :disabled="isLook"
              @click="addClinicOrstoreBtn(1)"
              >选择</el-button
            >
          </el-form-item>

          <el-form-item
            label="商城优惠券"
            prop="shop_coupon"
            class="coupon-box"
          >
            <draggable
              v-model="healthCardSetForm.shop_coupon"
              style="display: inline-block"
            >
              <transition-group name="flip-list" tag="div" class="tag-box">
                <div
                  v-for="(item, index) in healthCardSetForm.shop_coupon"
                  :key="index"
                >
                  <el-tag
                    :closable="!isLook"
                    size="samll"
                    :disable-transitions="isLook"
                    @close="handleClinicOrShopClose(2, item)"
                  >
                    <div>
                      <div class="coupon-name">{{ item.coupon_name }}</div>
                      <div class="message-text">{{ item.use_condition }}</div>
                    </div>
                  </el-tag>
                </div>
              </transition-group>
            </draggable>
            <el-button
              v-if="healthCardSetForm.shop_coupon.length < 20"
              type="primary"
              size="small"
              :disabled="isLook"
              @click="addClinicOrstoreBtn(2)"
              >选择</el-button
            >
          </el-form-item>
          <div class="prompt">
            注:只能选择未开启规格的商品，添加商品后再开启规格的商品，小程序端将不展示无法兑换哦！
          </div>

          <el-form-item
            label="养生卡权益商品"
            prop="clinic_coupon"
            class="clinic-coupon"
          >
            <el-button
              v-if="healthCardSetForm.goods_id == ''"
              type="primary"
              size="small"
              @click="addGoodsBtn"
              >选择</el-button
            >
            <template v-else>
              <el-tag
                size="samll"
                :disable-transitions="false"
                closable
                @close="handleClinicOrShopClose(3)"
              >
                <UploadImg
                  :f_thumb="healthCardSetForm.goods_image"
                  :f_thumb_str="healthCardSetForm.goods_image_str"
                  @emitImg="emitImg"
                >
                </UploadImg>
                <div class="prompt">
                  建议上传692*194大小的png、jpg、jpeg图片
                </div>
                <div class="right">
                  <div class="goods-name">
                    {{ healthCardSetForm.goods_name }}
                  </div>
                  <div class="goods-price">
                    {{ healthCardSetForm.goods_price }}
                  </div>
                </div>
              </el-tag>
            </template>
          </el-form-item>

          <el-form-item class="btn-box">
            <el-button @click="back">取 消</el-button>
            <el-button type="primary" @click="saveBtn('healthCardSetRef')"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 选择优惠券 -->
    <el-dialog
      title="选择优惠券"
      width="1000px"
      custom-class="dia-coupon"
      ref="diaTable"
      :visible.sync="couponDia"
      :before-close="closeCoupon"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="padding: 10px 20px">
        <div class="search_box">
          <div class="item">
            <span>优惠券名称</span>
            <el-input
              v-model="couponDiaForm.coupon_name"
              size="medium"
              clearable
              @change="getClickOrShopCoupon"
              placeholder="优惠券名称"
              class="input_width"
            ></el-input>
          </div>

          <div class="item">
            <span>优惠券分类</span>
            <el-select
              v-model="couponDiaForm.coupon_from"
              size="medium"
              disabled
              placeholder="优惠券分类"
              class="input_width"
            >
              <el-option label="诊疗优惠劵" :value="1"></el-option>
              <el-option label="商城优惠券" :value="2"></el-option>
            </el-select>
          </div>

          <div style="width: 100px">
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 20px"
              @click="getClickOrShopCoupon"
              >查询</el-button
            >
          </div>
        </div>
        <div style="border: 1px solid #f5f5f5">
          <el-table
            v-loading="couponDiaTableLoading"
            :data="couponTableDiaData"
            tooltip-effect="dark"
            height="400px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleDiaSelectionChange"
          >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column
              v-for="item in couponTableDiaHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'coupon_from'">
                  {{ scope.row[item.prop] | couponFromText }}
                </div>
                <div v-else-if="item.prop == 'message'">
                  {{ scope.row.use_condition }}
                </div>

                <div v-else-if="item.prop == 'use_time'">
                  <div v-if="scope.row['time_limit'] == 2">
                    {{ scope.row["time_start"] | dateFormat }} -
                    {{ scope.row["time_end"] | dateFormat }}
                  </div>
                  <div v-else>领取后{{ scope.row["time_days"] }}有效</div>
                </div>

                <div v-else-if="item.prop == 'show_time'">
                  {{ scope.row["show_start_time"] | dateFormat }} -
                  {{ scope.row["show_end_time"] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'total'">
                  {{ scope.row[item.prop] | totalText }}
                </div>
                <div v-else-if="item.prop == 'is_share'">
                  {{ scope.row[item.prop] | isShareText }}
                </div>
                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="between align-center">
          <!-- 分页 -->
          <pagination
            v-show="couponDiaTotalNum > 0"
            :total="couponDiaTotalNum"
            :page.sync="couponDiaPagination.page"
            :limit.sync="couponDiaPagination.pageNumber"
            @pagination="getClickOrShopCoupon"
          />
          <div style="padding: 10px 20px 0 0">
            <el-button size="medium" @click="closeCoupon">取 消</el-button>
            <el-button size="medium" type="primary" @click="confirmCoupon"
              >确 定</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 选择活动商品 -->
    <ChooseGood
      :chooseGoodDia.sync="chooseGoodDia"
      @checkGoods="checkGoods"
    ></ChooseGood>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import draggable from "vuedraggable";
import UploadImg from "@/components/uploadImg/index";
import Pagination from "@/components/Pagination/index";
import ChooseGood from "@/components/chooseGood/index";
import common from "../../../api/common";
export default {
  components: {
    UploadImg,
    Pagination,
    draggable,
    ChooseGood,
  },
  data() {
    return {
      healthCardSetForm: {
        card_title: "",
        title: "",
        desc: "",
        market_price: "",
        price: "",
        saved_day: "",
        clinic_coupon: [],
        shop_coupon: [],
        goods_image: "",
        goods_id: "",
      },
      rules: {
        card_title: [{ required: true, message: "请输入", trigger: "blur" }],
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        desc: [{ required: true, message: "请输入", trigger: "blur" }],
        market_price: [{ required: true, message: "请输入", trigger: "blur" }],
        price: [{ required: true, message: "请输入", trigger: "blur" }],
        saved_day: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      couponDia: false,
      couponDiaTotalNum: 0,
      couponDiaPagination: {
        page: 1,
        pageNumber: 10,
      },
      couponDiaForm: {
        coupon_name: "",
        coupon_from: 1,
      },
      couponDiaTableLoading: false,
      couponTableDiaHeader: [
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "优惠券分类",
          prop: "coupon_from",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "使用条件",
          prop: "message",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "发放总数",
          prop: "total",
          width: "80",
          align: "center",
          fixed: false,
        },
        {
          label: "使用时间",
          prop: "use_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "领取时间",
          prop: "show_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "是否可分享",
          prop: "is_share",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      couponTableDiaData: [],
      chooseGoodDia: false,
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    couponFromText(val) {
      switch (val) {
        case 1:
          return "诊疗优惠劵";
        case 2:
          return "商城优惠券";
      }
    },
    isShareText(val) {
      switch (val) {
        case 0:
          return "不可分享";
        case 1:
          return "可分享";
      }
    },
    totalText(val) {
      switch (val) {
        case -1:
          return "无限";
        default:
          return val;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
    pageTitle() {
      let type = Number(this.$route.query.type);
      switch (type) {
        case 1:
          return "添加养生卡";
        case 2:
          return "编辑养生卡";
      }
    },
    isLook() {
      return this.$route.query.type == 2;
    },
  },
  created() {
    if (this.routeQuery.type != 1) {
      // 编辑模式
      this.getHealthCardConfigInfo();
    } else if (this.routeQuery.copyId) {
      // 复制模式：获取要复制的数据
      this.copyHealthCardData();
    }
  },
  methods: {
    getHealthCardConfigInfo() {
      const loading = this.$loading();
      let params = {
        id: this.routeQuery.id,
      };
      marketing
        .getHealthCardConfigInfo(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.healthCardSetForm = Object.assign(
              {},
              this.healthCardSetForm,
              data.info
            );
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 复制养生卡数据
    copyHealthCardData() {
      const loading = this.$loading();
      let params = {
        id: this.routeQuery.copyId,
      };
      marketing
        .getHealthCardConfigInfo(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            // 复制所有数据，但清空id（因为是新建）
            const copiedData = JSON.parse(JSON.stringify(data.info));
            // 清空id相关字段，确保是新建
            delete copiedData.id;
            this.healthCardSetForm = Object.assign(
              {},
              this.healthCardSetForm,
              copiedData
            );
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    saveBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let interfaceName =
            this.routeQuery.type == 1
              ? "addHealthCardConfig"
              : "updateHealthCardConfig";
          let params = JSON.parse(JSON.stringify(this.healthCardSetForm));
          params.clinic_coupon_id = params.clinic_coupon
            .map((item) => item.coupon_data_id)
            .join(",");
          params.shop_coupon_id = params.shop_coupon
            .map((item) => item.coupon_data_id)
            .join(",");
          if (this.routeQuery.type != 1) {
            params.id = this.routeQuery.id;
            params = _.pick(params, ["id", "title", "desc", "goods_id", "goods_image"]);
          }
          params = _.omit(params, [
            "goods_name",
            "goods_image_str",
            "goods_price",
            "clinic_coupon",
            "shop_coupon",
          ]);
          marketing[interfaceName](params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("保存成功");
                this.couponDia = false;
                this.back();
              }
              loading.close();
            })
            .catch((err) => loading.close());
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /* **** 诊疗/商城优惠券---start **** */
    handleClinicOrShopClose(type, tag) {
      let key = "";
      switch (type) {
        case 1:
          key = "clinic_coupon";
          break;
        case 2:
          key = "shop_coupon";
          break;
        case 3:
          this.healthCardSetForm.goods_id = "";
          this.healthCardSetForm.goods_name = "";
          this.healthCardSetForm.goods_price = "";
          this.healthCardSetForm.goods_image = "";
          this.healthCardSetForm.goods_image_str = "";
          return;
      }
      this.healthCardSetForm[key].splice(
        this.healthCardSetForm[key].indexOf(tag),
        1
      );
    },
    addClinicOrstoreBtn(coupon_from) {
      this.couponDiaForm.coupon_from = coupon_from;
      this.couponDia = true;
      this.getClickOrShopCoupon();
    },
    // 获取优惠券列表
    getClickOrShopCoupon() {
      let params = Object.assign(
        {
          path_from: 2, // 1 积分 2 养生卡
        },
        this.couponDiaPagination,
        this.couponDiaForm
      );
      this.couponDiaTableLoading = true;
      common.getClickOrShopCoupon(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.couponTableDiaData = data.list;
          this.couponDiaTotalNum = data.total;
          this.couponDiaTableLoading = false;
        }
      });
    },
    // 选择优惠券
    handleDiaSelectionChange(val) {
      this.couponDiaData = val;
    },
    confirmCoupon() {
      if (!this.couponDiaData.length) {
        this.$message.warning("请选择优惠券");
        return;
      }
      let key =
        this.couponDiaForm.coupon_from == 1 ? "clinic_coupon" : "shop_coupon";
      this.healthCardSetForm[key] = _.uniqBy(
        [...this.healthCardSetForm[key], ...this.couponDiaData],
        "coupon_data_id"
      );
      if (this.healthCardSetForm[key].length > 20) {
        this.healthCardSetForm[key] = this.healthCardSetForm[key].slice(0, 20);
        this.$message.warning("已超过20张优惠券,仅保存前20张");
      }
      this.closeCoupon();
    },
    closeCoupon() {
      this.couponDiaData = [];
      this.couponDia = false;
    },
    /* **** 诊疗/商城优惠券---end **** */
    /* **** 权益商品---end **** */
    // 选择权限商品
    addGoodsBtn() {
      this.chooseGoodDia = true;
    },
    emitImg(data) {
      this.healthCardSetForm.goods_image = data.pic;
      this.healthCardSetForm.goods_image_str = data.path;
    },
    checkGoods(data) {
      this.healthCardSetForm.goods_id = data.goods_id;
      this.healthCardSetForm.goods_name = data.goods_name;
      this.healthCardSetForm.goods_price = data.price;
    },
    /* **** 权益商品---end **** */
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.healthCardSetRef-ruleForm {
  .el-form-item {
    display: flex;
    align-items: center;
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
      align-items: center;
    }
  }
  .desc {
    ::v-deep .el-form-item__content {
      height: 60px;
    }
  }
  .coupon-box {
    ::v-deep .el-form-item__content {
      height: auto;
      width: 90%;
      // display: flex;
      // flex-wrap: wrap;
    }
    .tag-box {
      display: flex;
      flex-wrap: wrap;
      .el-tag {
        display: inline-block;
        text-align: left;
        height: 100px;
        width: 200px;
        margin: 10px;
        position: relative;
        & > div {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          .coupon-name {
            font-size: 15px;
            font-weight: bold;
            white-space: pre-wrap;
          }
          .message-text {
            font-size: 14px;
            font-weight: bold;
            white-space: pre-wrap;
            padding-left: 6px;
          }
        }
        ::v-deep .el-icon-close {
          position: absolute;
          top: 6px !important;
          right: 10px !important;
        }
      }
    }
  }
  .clinic-coupon {
    ::v-deep .el-form-item__content {
      height: auto;
    }
    .el-tag {
      display: inline-block;
      display: flex;
      align-items: center;
      text-align: left;
      height: 150px;
      width: 300px;
      margin: 10px;
      position: relative;
      .prompt {
        position: absolute;
        bottom: 0;
        left: 0;
      }
      ::v-deep .el-icon-close {
        position: absolute;
        top: 6px !important;
        right: 10px !important;
      }
      .right {
        white-space: pre-wrap;
        padding-left: 4px;
        .goods-name {
          font-size: 15px;
          font-weight: bold;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .goods-price {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .btn-box {
    padding-left: 200px;
  }
}
</style>
<style lang="scss">
.dia-coupon {
  .search_box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span {
        display: inline-block;
        width: 110px;
        margin-right: 10px;
        text-align: right;
        white-space: nowrap;
      }
    }
    .input_width {
      width: 160px;
    }
  }
}
</style>
